import { eulerDegreesToRadians } from '../utils/camera';
export const directions = {
    INITIAL_DIRECTION: { x: -0.4, y: -0.2, z: -1 },
    FRONT: { x: 0, y: 0, z: -1 },
    FRONT_ANGLED_RIGHT: { x: -0.1, y: -0.1, z: -1 },
    FRONT_ANGLED: { x: -0.6, y: 0, z: -1 },
    FRONT_ANGLED_ABOVE_SMALL: { x: 0, y: -0.2, z: -1 },
    FRONT_ANGLED_ABOVE_RIGHT_SMALL: { x: -0.4, y: -0.2, z: -1 },
    FRONT_ANGLED_ABOVE_LEFT_SMALL: { x: 0.4, y: -0.2, z: -1 },
    FRONT_ANGLED_STEEP: { x: -2, y: 0, z: -1 },
    FRONT_ANGLED_ABOVE: { x: 0, y: -0.6, z: -1 },
    FRONT_ANGLED_BELOW: { x: 0, y: 0.3, z: -1 },
    BACK: { x: 0, y: 0, z: 1 },
    LEFT: { x: -1, y: 0, z: 0 },
    RIGHT: { x: 1, y: 0, z: 0 },
    LEFT_CORNER: { x: -1, y: 0, z: -1 },
    RIGHT_CORNER: { x: 1, y: 0, z: -1 },
    BACK_LEFT_CORNER: { x: -1, y: 0, z: 1 },
    BACK_RIGHT_CORNER: { x: 1, y: 0, z: 1 }
};
export const radiusLimits = {
    default: {
        min: 4,
        max: 17
    }
};
export const orbitLimits = {
    FRONT_SELECTED: {
        left: eulerDegreesToRadians(100),
        right: eulerDegreesToRadians(100),
        up: eulerDegreesToRadians(30),
        down: eulerDegreesToRadians(30)
    },
    FRONT_UPPER: {
        left: eulerDegreesToRadians(30),
        right: eulerDegreesToRadians(30),
        up: eulerDegreesToRadians(30),
        down: eulerDegreesToRadians(30)
    },
    FRONT: {
        left: eulerDegreesToRadians(90),
        right: eulerDegreesToRadians(90),
        up: eulerDegreesToRadians(30),
        down: eulerDegreesToRadians(30)
    },
    FRONT_ANGLED_RIGHT: {
        left: eulerDegreesToRadians(95),
        right: eulerDegreesToRadians(85),
        up: eulerDegreesToRadians(30),
        down: eulerDegreesToRadians(30)
    },
    FRONT_ANGLED: {
        left: eulerDegreesToRadians(120),
        right: eulerDegreesToRadians(60),
        up: eulerDegreesToRadians(30),
        down: eulerDegreesToRadians(30)
    },
    FRONT_ANGLED_STEEP: {
        left: eulerDegreesToRadians(153),
        right: eulerDegreesToRadians(27),
        up: eulerDegreesToRadians(30),
        down: eulerDegreesToRadians(30)
    },
    LEFT_CORNER: {
        left: eulerDegreesToRadians(90),
        right: eulerDegreesToRadians(45),
        up: eulerDegreesToRadians(30),
        down: eulerDegreesToRadians(30)
    },
    RIGHT_CORNER: {
        left: eulerDegreesToRadians(45),
        right: eulerDegreesToRadians(90),
        up: eulerDegreesToRadians(30),
        down: eulerDegreesToRadians(30)
    },
    FREE: {
        left: eulerDegreesToRadians(Infinity),
        right: eulerDegreesToRadians(Infinity),
        up: eulerDegreesToRadians(90),
        down: eulerDegreesToRadians(90)
    },
    ROOM: {
        left: eulerDegreesToRadians(45),
        right: eulerDegreesToRadians(45),
        up: eulerDegreesToRadians(45),
        down: eulerDegreesToRadians(45)
    }
};
// This is used to delay the camera focus when loading a solution either from vpc or a persisted scene
export const focusSolutionDelay = 400;
export const paddingMobile = {
    top: 30,
    right: 30,
    bottom: 30,
    left: 30
};
export const multiWallPadding = {
    top: 30,
    right: 30,
    bottom: 30,
    left: 30
};
export const singleWallPadding = {
    top: 60,
    right: 30,
    bottom: 60,
    left: 30
};
export const defaultPadding = {
    top: 60,
    right: 60,
    bottom: 60,
    left: 60
};
export const assemblySingleImagePadding = {
    top: 40,
    right: 40,
    bottom: 40,
    left: 40
};
export const roomPadding = {
    top: 200,
    right: 200,
    bottom: 200,
    left: 200
};
export const zoomLimits = {
    DEFAULT: {
        near: 1,
        far: 18
    },
    MOBILE: {
        near: 1,
        far: 10
    }
};
export const panLimits = {
    DEFAULT: {
        min: { x: -2, y: 0, z: -1 },
        max: { x: 2, y: 2, z: 1 }
    }
};
export const paxPadding = {
    top: 50,
    right: 50,
    bottom: 50,
    left: 50
};
export const defaultFocusOptions = {
    direction: directions.FRONT,
    orbitLimits: orbitLimits.FRONT,
    zoomLimits: zoomLimits.DEFAULT,
    padding: defaultPadding
};
export var Movement;
(function (Movement) {
    Movement["LEFT"] = "left";
    Movement["RIGHT"] = "right";
    Movement["UP"] = "up";
    Movement["DOWN"] = "down";
})(Movement || (Movement = {}));
//# sourceMappingURL=CameraApi.js.map